// import CONFIG from "CONFIG";

import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import ReduxLink from "apollo-link-redux";
import { HttpLink } from "apollo-link-http";
import store from "../stores/reduxStore";
import "cross-fetch/polyfill";

const link = ApolloLink.from([
    new ReduxLink(store),
    new HttpLink({
        uri: window._nounConfig.localGraphqlEndpoint,
        credentials: "include",
        fetch
    })
]);

export const apolloClient = new ApolloClient({
    cache: new InMemoryCache({
        cacheRedirects: {
            Query: {
                uploadDetail: (_, args, { getCacheKey }) =>
                    getCacheKey({
                        __typename: "UploadType",
                        id: args.uploadId
                    })
            }
        }
    }),
    link
});
